import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import SupportService from '@/core/services/support.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditSupportComponent extends Vue {

  supportService: any = new SupportService();
  sidebarService: any = new SidebarService();
  genericErr: any = [];
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  message: string = "";
  subject: string = "";

  mounted (){
    const _ = this;
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  edit(){
    const _ = this;
    let support = {
      message: _.message,
      subject: _.subject
    };
    let supportId: any = location.href.split("/");
    supportId = supportId[5];
    _.isLoading = true;
    _.supportService.edit(support, supportId).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/support');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let supportId: any = location.href.split("/");
    supportId = supportId[5];
    _.isLoading = true;
    _.supportService.getById(supportId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      console.log(data);
      _.message = data["data"].ticket.message;
      _.subject = data["data"].ticket.subject;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(message = '', subject = ''){
    const _ = this;
    _.genericErr = [];
    if(message == ''){
      _.genericErr.push("Por favor escribe el mensaje");
    }
    if(subject == ''){
      _.genericErr.push("Por favor escribe el tema");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }
}
